import { BookView } from '@life/frontend-model'

/**
 * Determines if the current User has permission to edit a Book.
 */
export function canEditBook(book: BookView): boolean {
  return !!book.role && book.role !== 'Viewer'
}
